import { ForwardedRef, forwardRef } from 'react';
import { Box } from '@zoopla-eng/zds-components/box';
import { RadioGroup } from '@zoopla-eng/zds-components/radio-group';
import { StyledLabel } from '../question.styles';

type BasicQuestionProps = {
    subtitle?: string;
    label: string;
    options: {
        id: string;
        value: string;
        label: string;
    }[];
    onChange: (value: string) => void;
    selectedValue?: string;
    ariaDescribedBy?: string;
};

export const BasicQuestion = forwardRef(
    (
        {
            subtitle,
            label,
            options,
            onChange,
            selectedValue = '',
            ariaDescribedBy
        }: BasicQuestionProps,
        ref: ForwardedRef<HTMLDivElement>
    ) => {
        return (
            <>
                <Box pb={subtitle ? '$S400' : undefined}>
                    <StyledLabel>{label}</StyledLabel>
                </Box>
                {subtitle && <span>{subtitle}</span>}
                <RadioGroup
                    items={options}
                    label={label}
                    onValueChange={onChange}
                    value={selectedValue}
                    ref={ref}
                    aria-describedby={ariaDescribedBy}
                />
            </>
        );
    }
);
